/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Narrows the diff to a single tile — flat because a tile is clicked as a whole, so dropped splits into its three reasons here. all (default) does not narrow. retained covers both Use Previous outcomes, so the tile shows every row holding prior-edition data; newJobMapCreated narrows to the half that also has a new mapping.
 */
export enum SurveyReplacementReviewDiffRowStatusFilter {
    ALL = 'all',
    REPLACED = 'replaced',
    NO_CHANGES = 'noChanges',
    NEED_SELECTION = 'needSelection',
    NEW_MAPPING = 'newMapping',
    DROPPED_NO_CUT = 'droppedNoCut',
    DROPPED_NO_MAPPING_OR_CUT = 'droppedNoMappingOrCut',
    DROPPED_NO_DATA_BEHIND_CUT = 'droppedNoDataBehindCut',
    NEW_JOB_MAP_CREATED = 'newJobMapCreated',
    RETAINED = 'retained',
}
